import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/Login';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgetPassword';
import Departments from './pages/Departments';
import Settings from './pages/Settings';
import SupportdSec1 from './pages/SupportdSec1';
import Users from './pages/Users';
import ProtectedRoute from './routes/ProtectedRoute';
import VerifyOtp from "./pages/VerifyOtp";
import Employees from './pages/Employees';
import ArchivAdmin from './pages/ArchivAdmin';
import PlanAdmin from './pages/PlanAdmin';
import Reports from './pages/Reports';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <Router>
      <Toaster position="top-center" reverseOrder={false} />

      <Routes>
        {/* Public */}
        <Route path="/" element={<LoginPage/>} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />

        {/* Protected - كل Route محدد له "page" بنفس مساره عشان ProtectedRoute يتحقق من allowedPage/roleId */}
        <Route path="/dashboard" element={<ProtectedRoute page="/dashboard"><Dashboard /></ProtectedRoute>} />
        <Route path="/departments" element={<ProtectedRoute page="/departments"><Departments /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute page="/settings"><Settings /></ProtectedRoute>} />
        <Route path="/SupportdSec1" element={<ProtectedRoute page="/SupportdSec1"><SupportdSec1 /></ProtectedRoute>} />
        <Route path="/users" element={<ProtectedRoute page="/users"><Users /></ProtectedRoute>} />
        <Route path="/employees" element={<ProtectedRoute page="/employees"><Employees /></ProtectedRoute>} />
        <Route path="/archivadmin" element={<ProtectedRoute page="/archivadmin"><ArchivAdmin /></ProtectedRoute>} />
        <Route path="/planadmin" element={<ProtectedRoute page="/planadmin"><PlanAdmin /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute page="/reports"><Reports /></ProtectedRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
